import React, { useState } from "react";
import Axios from "axios";

const ImageParagraphInput = (props) => {
  const iiid = `image-input-${props.id}`;
  const piid = `paragraph-input-${props.id}`;
  const [imageLink, setImageLink] = useState("");
  const setImageLink2 = () => {
    setImageLink(document.getElementById(iiid).value);
  };
  const saveField = () => {
    const field = `<div className='row'> <div className='col-md-6'> <img src='${imageLink}' alt=''/ className='img-fluid' /></div> 
    <div className='col-md-6'>
    <p className='card-text'>${document.getElementById(piid).value}</p>
    </div></div>`;
    Axios.post("https://fitness-junction-bots.onrender.com/api/savefield", {
      postId: props.postId,
      postField: field,
    })
      .then((data) => {})
      .catch((error) => console.log(error));
  };
  return (
    <div className="ipi-container text-start">
      <div>
        <div className="ii-container">
          <input
            type="text"
            id={iiid}
            className="w-100 p-2 mt-2 form-control "
            placeholder="Enter Your Image Link Here."
            onChange={setImageLink2}
          />
          <img src={imageLink} alt="" className="postbuilder-img" />
        </div>
        <div className="pi-container">
          <textarea
            id={piid}
            className="w-100 p-2 mt-2  form-control"
            y-2
            placeholder="Enter Your Paragraph Here."
          ></textarea>
        </div>
      </div>
      <button
        className="save-button btn btn-success mt-2"
        type="button"
        onClick={saveField}
      >
        Save
      </button>
    </div>
  );
};

export default ImageParagraphInput;
